"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Cookies = _interopRequireDefault(require("Cookies"));

var _q = _interopRequireDefault(require("q"));

var _Url = _interopRequireDefault(require("urlinator/Url"));

var _hubspot = _interopRequireDefault(require("hubspot.SafeStorage"));

var _CookieSetError = _interopRequireDefault(require("./errors/CookieSetError"));

var _RedirectError = _interopRequireDefault(require("./errors/RedirectError"));

var VISIT_MARKER_TEMPLATE = 'visited.${lb}.at';
var CSRF_KEY_TEMPLATE = 'csrf.${lb}';
var URL_LOADED = _Url.default.loaded;
var IS_SAFARI = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');

var BaseCookieLogin =
/*#__PURE__*/
function () {
  function BaseCookieLogin(cookieLoadBalancers, loginRequest, prepRequest, visitPath) {
    (0, _classCallCheck2.default)(this, BaseCookieLogin);
    this.cookieLoadBalancers = cookieLoadBalancers;
    this.prepRequest = prepRequest;
    this.loginRequest = loginRequest;
    this.visitPath = visitPath;
    this.currentDomain = '.' + location.hostname.split('.').slice(-2).join('.');
    this.domainPreps = this.domainPreps.bind(this);
    this.collectDomainPreps = this.collectDomainPreps.bind(this);
    this.collectLoginResponses = this.collectLoginResponses.bind(this);
  }

  (0, _createClass2.default)(BaseCookieLogin, [{
    key: "loginPrep",
    value: function loginPrep() {
      var _this = this;

      if (!this.loginPrepPromise) {
        if (IS_SAFARI) {
          this.loginPrepPromise = _q.default.Promise.all(this.domainPreps()).then(function (preps) {
            return _this.collectDomainPreps.apply(_this, (0, _toConsumableArray2.default)(preps));
          }).catch(function (error) {
            console.error(error);

            if (error.name === 'RedirectError') {
              throw error;
            }
          });
        } else {
          this.loginPrepPromise = _q.default.Promise.resolve();
        }
      }

      return this.loginPrepPromise;
    }
  }, {
    key: "domainPreps",
    value: function domainPreps() {
      return this.cookieLoadBalancers.map(this.prepRequest);
    }
  }, {
    key: "collectDomainPreps",
    value: function collectDomainPreps() {
      var _this2 = this;

      var redirectLoadBalancers = [];

      for (var _len = arguments.length, domainPreps = new Array(_len), _key = 0; _key < _len; _key++) {
        domainPreps[_key] = arguments[_key];
      }

      domainPreps.forEach(function (_ref, i) {
        var visited = _ref.visited;
        var loadBalancer = _this2.cookieLoadBalancers[i];
        var marker = VISIT_MARKER_TEMPLATE.replace('${lb}', loadBalancer);

        if (visited) {
          _hubspot.default.removeItem(marker);
        } else {
          var maybeMarkerTimestamp = _hubspot.default.getItem(marker);

          var markerSetAt = maybeMarkerTimestamp != null ? +maybeMarkerTimestamp : 0;
          var now = new Date().getTime();

          if (now - markerSetAt < 120000) {
            _hubspot.default.removeItem(marker);

            throw new _CookieSetError.default();
          }

          redirectLoadBalancers.push(loadBalancer);

          _hubspot.default.setItem(marker, now);
        }
      });
      this.visitUnvisited(redirectLoadBalancers);
    }
  }, {
    key: "visitUnvisited",
    value: function visitUnvisited(loadBalancers) {
      var _this3 = this;

      if (loadBalancers.length) {
        var visitUrl = URL_LOADED.clone().href;
        loadBalancers.forEach(function (loadBalancer) {
          visitUrl = new _Url.default(_this3.visitPath, {
            lb: loadBalancer,
            params: {
              redirect: visitUrl
            }
          }).href;
        });
        window.location = visitUrl;
        throw new _RedirectError.default();
      }
    }
  }, {
    key: "login",
    value: function login(credentials) {
      var _this4 = this;

      return this.loginPrep().then(function () {
        return _q.default.Promise.all(_this4.loginRequests(credentials)).then(function (responses) {
          return _this4.collectLoginResponses.apply(_this4, (0, _toConsumableArray2.default)(responses));
        });
      }).catch(function (response) {
        try {
          response.responseJSON = response.responseJSON || JSON.parse(response.responseText);
        } catch (ex) {
          console.error("Unable to parse error response JSON \"" + response.responseText + "\"");
        }

        throw response;
      });
    }
  }, {
    key: "loginRequests",
    value: function loginRequests(credentials) {
      var _this5 = this;

      return this.cookieLoadBalancers.map(function (loadBalancer) {
        return _this5.loginRequest(credentials, loadBalancer);
      });
    }
  }, {
    key: "collectLoginResponses",
    value: function collectLoginResponses() {
      var _this6 = this;

      for (var _len2 = arguments.length, loginResponses = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        loginResponses[_key2] = arguments[_key2];
      }

      loginResponses.forEach(function (_ref2, i) {
        var csrfToken = _ref2.csrfToken;
        var csrfKey = CSRF_KEY_TEMPLATE.replace('${lb}', _this6.cookieLoadBalancers[i]);

        _Cookies.default.set(csrfKey, csrfToken, {
          path: '/',
          secure: true,
          expires: 365,
          domain: _this6.currentDomain
        });
      });
      return loginResponses;
    }
  }, {
    key: "ignoreRedirectWrapper",
    value: function ignoreRedirectWrapper(failureHandler) {
      return function (response) {
        if (response.name !== 'RedirectError') {
          failureHandler(response);
        }
      };
    }
  }]);
  return BaseCookieLogin;
}();

var _default = BaseCookieLogin;
exports.default = _default;
module.exports = exports.default;